import EmailAddress from "common/values/email-address/email-address";

export default class ResetPasswordRequestAPIRequest {
    email: string;

    constructor(email: EmailAddress) {
        this.email = email.value;
    }
}
